import debounce from 'lodash.debounce'
import { useMemo } from 'react'

/**
 * Helper hook to make a debounced callback by the delay given
 *
 * Be wary that this function will change each time
 * @param callback The function that will be called
 * @param delay The number of milliseconds the debounce will be
 * @param deps List of dependencies for when to update the callback function, otherwise it will be the version originally passed in
 * @returns The debounced function
 */
function useDebouncedCallback<T extends(...args: Array<any>) => any>(
  callback: T,
  delay: number,
  deps: Array<any>,
): T {
  return useMemo(() => {
    return debounce(callback, delay) as unknown as T
  // oxlint-disable-next-line react-hooks/exhaustive-deps
  }, [delay, ...deps])
}

export default useDebouncedCallback
